import RunningProcess from "./running_process";

import type { ApiPipelineArgument, ApiPipelineLog } from "avvir";
import type ProcessStatus from "./enums/process_status";
import type { DateLike, ModifyPartial } from "type_aliases";
import type { RunningProcessStatus } from "avvir";

type PipelineArgument = ModifyPartial<Pipeline, {
  startDate?: DateLike
  endDate?: DateLike
  startTime?: DateLike
  endTime?: DateLike
  status?: ProcessStatus | RunningProcessStatus
}>

export default class Pipeline extends RunningProcess {
  constructor({
    id,
    name,
    externalId,
    externalUrl,
    startTime,
    startDate,
    endDate,
    endTime,
    firebaseProjectId,
    firebaseFloorId,
    firebaseScanDatasetId,
    updates,
    status,
    userEmail,
    logs,
    downloadUrl,
    downloadFileName,
    retryArguments,
  }: PipelineArgument = {}) {
    super({id, name, status, startDate: startDate || startTime, endDate: endDate || endTime, updates});
    this.externalId = externalId || "";
    this.externalUrl = externalUrl || null;
    this.firebaseProjectId = firebaseProjectId || null;
    this.firebaseFloorId = firebaseFloorId || null;
    this.firebaseScanDatasetId = firebaseScanDatasetId || null;
    this.userEmail = userEmail || null;
    this.logs = logs || [];
    this.downloadUrl = downloadUrl || null;
    this.downloadFileName = downloadFileName || null;
    this.retryArguments = retryArguments || null;
  }

  externalId: string;
  externalUrl: string;

  firebaseProjectId: string;
  firebaseFloorId: string;
  firebaseScanDatasetId: string;
  userEmail: string;
  logs: ApiPipelineLog[];
  downloadUrl: string;
  downloadFileName: string;
  retryArguments: ApiPipelineArgument | null;
}
